import { AdminSideBar } from './AdminSideBar';

const SidebarMenu = () => {
  return (
    <div className="app-sidebar-menu overflow-hidden flex-column-fluid">
      <div
        className="app-sidebar-wrapper hover-scroll-overlay-y my-5 h-100"
        data-kt-scroll="true"
        data-kt-scroll-activate="true"
        data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
        data-kt-scroll-height="auto"
        data-kt-scroll-offset="5px"
        data-kt-scroll-save-state="true"
        data-kt-scroll-wrappers="#kt_app_sidebar_menu"
        id="kt_app_sidebar_menu_wrapper"
      >
        <div
          className="menu menu-column menu-rounded menu-sub-indention px-3 h-100"
          data-kt-menu="true"
          data-kt-menu-expand="false"
          id="#kt_app_sidebar_menu"
        >
          <AdminSideBar />
        </div>
      </div>
    </div>
  );
};

export { SidebarMenu };
